import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { genPw } from '../../lib/onboardShop/helpers';

export const StepOwner = ({ owner, setOwner, showPw, setShowPw, showPhone = false }) => (
  <>
    <h3 className="admin-info-header">Owner account</h3>
    <div className="sub" style={{ color: 'var(--mute)', marginBottom: 14 }}>
      {showPhone
        ? 'The owner will receive a welcome email with these credentials. Mobile is optional and stored for booking notifications.'
        : 'This person becomes the shop_admin. No email is sent — copy the credentials at the end.'}
    </div>
    <div className="wiz-row">
      <div className="field">
        <label>Full name</label>
        <input className="inp" value={owner.name} onChange={(e) => setOwner({ ...owner, name: e.target.value })} data-testid="wiz-owner-name" />
      </div>
      <div className="field">
        <label>Email</label>
        <input className="inp" type="email" value={owner.email} onChange={(e) => setOwner({ ...owner, email: e.target.value })} data-testid="wiz-owner-email" />
      </div>
    </div>
    {showPhone && (
      <div className="field">
        <label>Mobile <small style={{ color: 'var(--mute)' }}>E.164, e.g. +447700900123 — required</small></label>
        <input className="inp" type="tel" required value={owner.phone} onChange={(e) => setOwner({ ...owner, phone: e.target.value })} placeholder="+447700900123" data-testid="wiz-owner-phone" />
      </div>
    )}
    <div className="field">
      <label>Password (admin-set)</label>
      <div style={{ display: 'flex', gap: 8 }}>
        <input className="inp" type={showPw ? 'text' : 'password'} value={owner.password} onChange={(e) => setOwner({ ...owner, password: e.target.value })} data-testid="wiz-owner-password" />
        <button type="button" className="btn s" onClick={() => setShowPw(!showPw)} data-testid="wiz-owner-pw-toggle">
          {showPw ? <EyeOff size={14} /> : <Eye size={14} />}
        </button>
        <button type="button" className="btn s" onClick={() => setOwner({ ...owner, password: genPw() })} data-testid="wiz-owner-pw-regen">Regenerate</button>
      </div>
      <small style={{ color: 'var(--mute)' }}>Min 8 characters. {showPhone ? 'Sent to the owner by email.' : 'Copy at the end — no email will be sent.'}</small>
    </div>
  </>
);
